import Overview from '@rebuild/materials/shared/quote/SlideOverview.vue';
import MobFull from '@/rebuild/materials/shared/quote/mobile/SlideMobFull.vue';
import Pure from './pure.vue';
import MobPure from './mob-pure.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull,

	pure: Pure,
	'mob-pure': MobPure
};
